import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
export function PricingOffer() {
  return <section className="py-14 px-4 bg-white" data-id="element-201">
      <div className="max-w-4xl mx-auto text-center" data-id="element-202">
        <div className="mb-8" data-id="element-203">
          <h2 className="text-3xl md:text-5xl font-black mb-3 tracking-tight" data-id="element-204">
            Precio de lanzamiento
          </h2>
          <p className="text-xl text-brand-brown/80 font-playfair italic" data-id="element-205">
            ¿Cuánto cuesta todo esto?
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-cream rounded-3xl p-6 md:p-10 shadow-2xl border-2 border-brand-green/20 relative" data-id="element-206">
          {/* Urgency Badge */}
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-full max-w-[95%] md:max-w-lg" data-id="element-207">
            <div className="bg-brand-red text-white text-sm md:text-base font-black py-2.5 px-5 rounded-full shadow-xl flex items-center justify-center gap-2 border-2 border-white uppercase tracking-wider" data-id="element-208">
              <span className="text-lg" data-id="element-209">⏰</span> OFERTA SOLO POR HOY — SE
              CIERRA SIN AVISO
            </div>
          </div>

          <div className="mt-8 mb-8" data-id="element-210">
            <p className="text-brand-brown/60 font-bold text-lg mb-3 uppercase tracking-widest" data-id="element-211">
              Precio regular:{' '}
              <span className="line-through decoration-brand-red/50 decoration-2" data-id="element-212">
                $39.990
              </span>
            </p>
            <PriceDisplay amount="7.990" fixedSymbol="$" className="text-6xl md:text-8xl text-brand-dark-green font-black tracking-tighter" data-id="element-213" />
          </div>

          <CTAButton className="w-full md:w-[80%] text-xl md:text-2xl py-5 shadow-[0_10px_30px_rgba(45,90,61,0.4)] mb-6" data-id="element-214">
            AGREGAR AL CARRITO →
          </CTAButton>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-brand-brown/90 font-bold text-base mb-10 bg-white/50 py-3 px-6 rounded-2xl inline-flex" data-id="element-215">
            <span className="flex items-center gap-2" data-id="element-216">
              <CheckIcon className="w-5 h-5 text-brand-green stroke-[3]" data-id="element-217" /> Un
              solo pago
            </span>
            <span className="flex items-center gap-2" data-id="element-218">
              <CheckIcon className="w-5 h-5 text-brand-green stroke-[3]" data-id="element-219" /> Sin
              cuotas
            </span>
            <span className="flex items-center gap-2" data-id="element-220">
              <CheckIcon className="w-5 h-5 text-brand-green stroke-[3]" data-id="element-221" />{' '}
              Acceso eterno
            </span>
          </div>

          {/* Guarantee Box */}
          <div className="bg-white rounded-2xl p-6 md:p-7 border-2 border-brand-green/30 text-left flex flex-col md:flex-row gap-5 items-start shadow-lg relative overflow-hidden" data-id="element-222">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-green/5 rounded-bl-full -z-10" data-id="element-223" />

            <div className="bg-gradient-to-br from-brand-green/20 to-brand-green/5 p-4 rounded-xl shrink-0 border border-brand-green/20" data-id="element-224">
              <ShieldCheckIcon className="w-10 h-10 text-brand-green" data-id="element-225" />
            </div>
            <div data-id="element-226">
              <h4 className="text-xl md:text-2xl font-black mb-3 font-playfair text-brand-dark-green leading-tight" data-id="element-227">
                Garantía 30 Días "Amalo o Te Lo Devuelvo"
              </h4>
              <p className="text-brand-brown/80 text-base leading-relaxed" data-id="element-228">
                Probalo por 30 días completos sin ningún riesgo. Si por
                cualquier razón no te gusta, escribime un email y{' '}
                <strong className="text-brand-brown font-black bg-brand-amber-light/50 px-1" data-id="element-229">
                  te devuelvo el 100% de tu dinero
                </strong>{' '}
                —{' '}
                <span className="underline decoration-brand-green/40 decoration-2 underline-offset-4 font-bold" data-id="element-230">
                  sin preguntas, sin letra chica, sin vueltas.
                </span>
              </p>
            </div>
          </div>

          {/* Trust Logos Placeholder */}
          <div className="mt-8 pt-6 border-t-2 border-brand-brown/5" data-id="element-231">
            <p className="text-sm text-brand-brown/50 uppercase tracking-[0.2em] font-black mb-4" data-id="element-232">
              Pago 100% Seguro
            </p>
            <div className="flex justify-center gap-6 opacity-50 grayscale" data-id="element-233">
              <div className="px-4 py-2 border-2 border-brand-brown/30 rounded-lg text-base font-black italic" data-id="element-234">
                VISA
              </div>
              <div className="px-4 py-2 border-2 border-brand-brown/30 rounded-lg text-base font-black" data-id="element-235">
                Mastercard
              </div>
              <div className="px-4 py-2 border-2 border-brand-brown/30 rounded-lg text-base font-black text-blue-800" data-id="element-236">
                PayPal
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}